import { makeApiRequest } from "@/src/lib/api-request";
import { useMutation, useQueryClient } from "@tanstack/react-query"
import {useUser} from '@/src/store/user-store'

interface SubscribeDto {
    eventId : string
    channelId : string
}


export const useSubscribeChannelMutation = () => {
    const queryClient = useQueryClient()
    const {user} = useUser()
    return useMutation({
        mutationKey : ['subscribe-channel', user],
        mutationFn : async (props : SubscribeDto) => {
            await makeApiRequest({
                url : '/Subscribe/addSubscribe',
                method : 'POST',
                data : {
                    eventId : props.eventId,
                    channelId : props.channelId
                },
                isAuthenticated : true,
                fallbackError : 'failed to subscribe video',
                isV3Api:true
            })    
            
        }
    });
}

export const useUnsubscribeChannelMutation = () => {
    const queryClient = useQueryClient()
    const {user} = useUser()
    return useMutation({
        mutationKey : ['unsubscribe-channel', user],
        mutationFn : async (props : SubscribeDto) => {
            
            await makeApiRequest({
                url : '/Subscribe/deleteSubscribe',
                method : 'POST',
                data : {
                    eventId : props.eventId,
                    channelId : props.channelId
                },
                isAuthenticated :true,
                fallbackError : 'failed to unsubscribe channel',
                isV3Api:true
            })    
            
        }
    });
}